"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

exports.ImagePickerFixer = styled_components_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    align-self: self-start;\n"], ["\n    position: relative;\n    align-self: self-start;\n"])));
exports.ImagePickerContainerSmall = styled_components_1.default(function (_a) {
  var screenWidth = _a.screenWidth,
      rest = __rest(_a, ["screenWidth"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-flow: row nowrap;\n    width: ", "px;\n    height: 120px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    align-items: center;\n    padding: 0 20px;\n"], ["\n    display: flex;\n    flex-flow: row nowrap;\n    width: ", "px;\n    height: 120px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    align-items: center;\n    padding: 0 20px;\n"])), function (_a) {
  var screenWidth = _a.screenWidth;
  return screenWidth - 24;
});
exports.ImagePickerContainerDefault = styled_components_1.default(react_native_1.View)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-flow: row wrap;\n    width: 100%;\n"], ["\n    display: flex;\n    flex-flow: row wrap;\n    width: 100%;\n"])));
exports.ImageCircleBaseContainer = styled_components_1.default(react_native_1.View)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #e0dde7;\n    border-radius: 50%;\n    cursor: pointer;\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #e0dde7;\n    border-radius: 50%;\n    cursor: pointer;\n"])));
exports.UnfoldMoreIconContainer = styled_components_1.default(react_native_1.View)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: absolute;\n    top: -20px;\n    right: 10px;\n    opacity: 0.5;\n"], ["\n    position: absolute;\n    top: -20px;\n    right: 10px;\n    opacity: 0.5;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;